export const black = '#000000'
export const white = '#ffffff'
export const red='#e73339'

export const darkGray = '#191919'
export const gray = '#7E7E7E'
export const offWhite = '#4F4F4F'

export const neonLime = '#CAFC34'
export const neonLimeLight = '#D9FF69'
export const neonLimeDark = '#A8D819'
